import { h, ComponentChildren, FunctionComponent } from 'preact'; /** @jsx h */
import { useState, useEffect } from 'preact/hooks';
import { clsx } from 'clsx';

import { Session } from '@pyqml/model';

type ISelectorProps = {
    payMode: Session.SubscriptionDuration;
    setPayMode: (mode: Session.SubscriptionDuration) => void;
}

type IPayModeSelectProps = {
    children: (Selector: FunctionComponent<any>, payMode: Session.SubscriptionDuration) => any
}

const Selector: FunctionComponent<ISelectorProps> = (props) => {
    
    return <p>
        <a href="#" className={clsx(`btn btn-outline-primary${props.payMode === "month" ? "-active" : ""}`)} onClick={() => props.setPayMode("month")}>Pay Monthly</a>
        <a href="#" className={clsx(`btn btn-outline-primary${props.payMode === "year" ? "-active" : ""}`)} onClick={() => props.setPayMode("year")}>
            <span className="badge badge-warning ml-2">Save 25%</span>
            Pay Annually
        </a>
    </p>
}

export const PayModeSelect = (props: IPayModeSelectProps) => {

    const [payMode, setPayMode] = useState<Session.SubscriptionDuration>('year');
    
    return props.children((p) => <Selector payMode={payMode} setPayMode={setPayMode} {...p}/>, payMode)
}
